import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_SUMMARY_METRICS_QUERY_KEY = 'woop-summary-metrics';

export const getWorkloadsSummaryMetricsQueryKey = ({
  clusterId,
  fromTime,
  toTime,
}: { clusterId?: string; fromTime?: string; toTime?: string } = {}) =>
  [WOOP_SUMMARY_METRICS_QUERY_KEY, clusterId, fromTime, toTime] as const;

type UseWorkloadsSummaryMetricsQueryArgs = {
  clusterId: string;
  enabled: boolean;
  fromTime: string;
  toTime: string;
};

export const getWorkloadsSummaryMetricsQueryOptions = ({
  clusterId,
  enabled,
  fromTime,
  toTime,
}: UseWorkloadsSummaryMetricsQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadsSummaryMetricsQueryKey({
      clusterId,
      fromTime,
      toTime,
    }),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getWorkloadsSummaryMetrics({
          clusterId,
          fromTime,
          toTime,
        });
      return data;
    },
    placeholderData: keepPreviousData,
    enabled,
  });

export const useWorkloadsSummaryMetricsQuery = (
  args: UseWorkloadsSummaryMetricsQueryArgs
) => {
  const { data, isLoading, isFetching, isRefetching, error, refetch } =
    useQuery(getWorkloadsSummaryMetricsQueryOptions(args));

  return {
    data,
    isLoading,
    isFetching,
    isRefetching,
    error,
    refetch,
  };
};
